/** @file bindingLabel: the human label of a binding id (its row in bindingLabels, else the id spelled out). */
import { bindingLabels } from './bindingLabels';

/** `tree.selectPrev` without a row reads "Tree: select prev"; never an empty string. */
export function bindingLabel(id: string): string {
  const known = bindingLabels[id];
  if (known !== undefined) return known;
  const [area = '', ...rest] = id.split('.');
  const words = rest.join(' ').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return words === '' ? area : `${area.charAt(0).toUpperCase()}${area.slice(1)}: ${words}`;
}
